import { render } from "./Score.vue?vue&type=template&id=639259b4"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"
script.render = render

export default script